export { default as Img200 } from './processed/200/I-Think-Were-Alone-Now.jpg';
export { default as Img400 } from './processed/400/I-Think-Were-Alone-Now.jpg';
export { default as Imgthumb } from './processed/thumb/I-Think-Were-Alone-Now.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/I-Think-Were-Alone-Now.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/I-Think-Were-Alone-Now.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      49,
      116,
      132
    ],
    "_population": 14,
    "_hsl": [
      0.532128514056225,
      0.45856353591160226,
      0.35490196078431374
    ]
  },
  "LightVibrant": {
    "_rgb": [
      211,
      185,
      156
    ],
    "_population": 1182,
    "_hsl": [
      0.08787878787878788,
      0.3846153846153844,
      0.7196078431372549
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      19,
      99,
      114
    ],
    "_population": 446,
    "_hsl": [
      0.5263157894736842,
      0.7142857142857143,
      0.2607843137254902
    ]
  },
  "Muted": {
    "_rgb": [
      160,
      121,
      90
    ],
    "_population": 1183,
    "_hsl": [
      0.07380952380952378,
      0.27999999999999997,
      0.4901960784313726
    ]
  },
  "LightMuted": {
    "_rgb": [
      214,
      209,
      193
    ],
    "_population": 1417,
    "_hsl": [
      0.12698412698412692,
      0.20388349514563123,
      0.7980392156862746
    ]
  },
  "DarkMuted": {
    "_rgb": [
      74,
      53,
      35
    ],
    "_population": 2860,
    "_hsl": [
      0.07692307692307691,
      0.3577981651376147,
      0.21372549019607845
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/I-Think-Were-Alone-Now.js